import { ThemeConfig } from './button-theme.config';

/**
 * Light mode theme configuration for all button themes and modes.
 * All CSS classes are statically defined for Tailwind CSS 4 compatibility.
 */
export const LIGHT_THEME_CONFIG: ThemeConfig = {
  primary: {
    filled: {
      enabled: {
        bg: 'bg-btn-primary-bg hover:bg-btn-primary-bg-hover active:bg-btn-primary-bg-pressed',
        text: 'text-btn-primary-text',
        border: 'border-btn-primary-border hover:border-btn-primary-border-hover active:border-btn-primary-border-pressed!',
      },
      active: {
        bg: 'bg-btn-primary-bg-pressed!',
        text: 'text-btn-primary-text',
        border: 'border-btn-primary-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-primary-bg-disabled',
        text: 'text-btn-primary-text-disabled',
        border: 'border-btn-primary-border-disabled',
      },
    },
    outlined: {
      enabled: {
        bg: 'bg-btn-primary-outlined-bg hover:bg-btn-primary-outlined-bg-hover active:bg-btn-primary-outlined-bg-pressed',
        text: 'text-btn-primary-outlined-text hover:text-btn-primary-outlined-text-hover active:text-btn-primary-outlined-text-pressed',
        border: 'border-btn-primary-outlined-border hover:border-btn-primary-outlined-border-hover active:border-btn-primary-outlined-border-pressed!',
      },
      active: {
        bg: 'bg-btn-primary-outlined-bg-pressed!',
        text: 'text-btn-primary-outlined-text-pressed',
        border: 'border-btn-primary-outlined-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-primary-outlined-bg-disabled',
        text: 'text-btn-primary-outlined-text-disabled',
        border: 'border-btn-primary-outlined-border-disabled',
      },
    },
    flat: {
      enabled: {
        bg: 'bg-transparent hover:bg-btn-primary-bg-hover active:bg-btn-primary-bg-pressed',
        text: 'text-btn-primary-flat-text hover:text-btn-primary-flat-text-hover active:text-btn-primary-flat-text-pressed',
        border: 'border-btn-primary-border-flat hover:border-btn-primary-border-flat-hover active:border-btn-primary-border-flat-pressed!',
      },
      active: {
        bg: 'bg-btn-primary-bg-pressed!',
        text: 'text-btn-primary-flat-text-pressed',
        border: 'border-btn-primary-border-flat-pressed!',
      },
      disabled: {
        bg: 'bg-transparent',
        text: 'text-btn-primary-flat-text-disabled',
        border: 'border-btn-primary-border-flat-disabled',
      },
    },
  },
  secondary: {
    filled: {
      enabled: {
        bg: 'bg-btn-secondary-bg hover:bg-btn-secondary-bg-hover active:bg-btn-secondary-bg-pressed',
        text: 'text-btn-secondary-text',
        border: 'border-btn-secondary-border hover:border-btn-secondary-border-hover active:border-btn-secondary-border-pressed',
      },
      active: {
        bg: 'bg-btn-secondary-bg-pressed!',
        text: 'text-btn-secondary-text',
        border: 'border-btn-secondary-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-secondary-bg-disabled',
        text: 'text-btn-secondary-text-disabled',
        border: 'border-btn-secondary-border-disabled',
      },
    },
    outlined: {
      enabled: {
        bg: 'bg-btn-secondary-outlined-bg hover:bg-btn-secondary-outlined-bg-hover active:bg-btn-secondary-outlined-bg-pressed',
        text: 'text-btn-secondary-outlined-text hover:text-btn-secondary-outlined-text-hover active:text-btn-secondary-outlined-text-pressed',
        border: 'border-btn-secondary-outlined-border hover:border-btn-secondary-outlined-border-hover active:border-btn-secondary-outlined-border-pressed',
      },
      active: {
        bg: 'bg-btn-secondary-outlined-bg-pressed!',
        text: 'text-btn-secondary-outlined-text-pressed',
        border: 'border-btn-secondary-outlined-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-secondary-outlined-bg-disabled',
        text: 'text-btn-secondary-outlined-text-disabled',
        border: 'border-btn-secondary-outlined-border-disabled',
      },
    },
    flat: {
      enabled: {
        bg: 'bg-transparent hover:bg-btn-secondary-bg-hover active:bg-btn-secondary-bg-pressed',
        text: 'text-btn-secondary-flat-text hover:text-btn-secondary-flat-text-hover active:text-btn-secondary-flat-text-pressed',
        border: 'border-btn-secondary-border-flat hover:border-btn-secondary-border-flat-hover active:border-btn-secondary-border-flat-pressed',
      },
      active: {
        bg: 'bg-btn-secondary-bg-pressed!',
        text: 'text-btn-secondary-flat-text-pressed',
        border: 'border-btn-secondary-border-flat-pressed!',
      },
      disabled: {
        bg: 'bg-transparent',
        text: 'text-btn-secondary-flat-text-disabled',
        border: 'border-btn-secondary-border-flat-disabled',
      },
    },
  },
  danger: {
    filled: {
      enabled: {
        bg: 'bg-btn-danger-bg hover:bg-btn-danger-bg-hover active:bg-btn-danger-bg-pressed',
        text: 'text-btn-danger-text',
        border: 'border-btn-danger-border hover:border-btn-danger-border-hover active:border-btn-danger-border-pressed!',
      },
      active: {
        bg: 'bg-btn-danger-bg-pressed!',
        text: 'text-btn-danger-text',
        border: 'border-btn-danger-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-danger-bg-disabled',
        text: 'text-btn-danger-text-disabled',
        border: 'border-btn-danger-border-disabled',
      },
    },
    outlined: {
      enabled: {
        bg: 'bg-btn-danger-outlined-bg hover:bg-btn-danger-outlined-bg-hover active:bg-btn-danger-outlined-bg-pressed',
        text: 'text-btn-danger-outlined-text hover:text-btn-danger-outlined-text-hover active:text-btn-danger-outlined-text-pressed',
        border: 'border-btn-danger-outlined-border hover:border-btn-danger-outlined-border-hover active:border-btn-danger-outlined-border-pressed!',
      },
      active: {
        bg: 'bg-btn-danger-outlined-bg-pressed!',
        text: 'text-btn-danger-outlined-text-pressed',
        border: 'border-btn-danger-outlined-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-danger-outlined-bg-disabled',
        text: 'text-btn-danger-outlined-text-disabled',
        border: 'border-btn-danger-outlined-border-disabled',
      },
    },
    flat: {
      enabled: {
        bg: 'bg-transparent hover:bg-btn-danger-bg-hover active:bg-btn-danger-bg-pressed',
        text: 'text-btn-danger-flat-text hover:text-btn-danger-flat-text-hover active:text-btn-danger-flat-text-pressed',
        border: 'border-btn-danger-border-flat hover:border-btn-danger-border-flat-hover active:border-btn-danger-border-flat-pressed!',
      },
      active: {
        bg: 'bg-btn-danger-bg-pressed!',
        text: 'text-btn-danger-flat-text-pressed',
        border: 'border-btn-danger-border-flat-pressed!',
      },
      disabled: {
        bg: 'bg-transparent',
        text: 'text-btn-danger-flat-text-disabled',
        border: 'border-btn-danger-border-flat-disabled',
      },
    },
  },
  ai: {
    filled: {
      enabled: {
        bg: 'bg-btn-ai-bg hover:bg-btn-ai-bg-hover active:bg-btn-ai-bg-pressed',
        text: 'text-btn-ai-text hover:text-btn-ai-text active:text-btn-ai-text-pressed',
        border: 'border-btn-ai-border hover:border-btn-ai-border-hover active:border-btn-ai-border-pressed!',
      },
      active: {
        bg: 'bg-btn-ai-bg-pressed!',
        text: 'text-btn-ai-text-pressed',
        border: 'border-btn-ai-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-ai-bg-disabled',
        text: 'text-btn-ai-text-disabled',
        border: 'border-btn-ai-border-disabled',
      },
    },
    outlined: {
      enabled: {
        bg: 'bg-btn-ai-outlined-bg hover:bg-btn-ai-outlined-bg-hover active:bg-btn-ai-outlined-bg-pressed',
        text: 'text-btn-ai-outlined-text hover:text-btn-ai-outlined-text-hover active:text-btn-ai-outlined-text-pressed',
        border: 'border-btn-ai-outlined-border hover:border-btn-ai-outlined-border-hover active:border-btn-ai-outlined-border-pressed!',
      },
      active: {
        bg: 'bg-btn-ai-outlined-bg-pressed!',
        text: 'text-btn-ai-outlined-text-pressed',
        border: 'border-btn-ai-outlined-border-pressed!',
      },
      disabled: {
        bg: 'bg-btn-ai-outlined-bg-disabled',
        text: 'text-btn-ai-outlined-text-disabled',
        border: 'border-btn-ai-outlined-border-disabled',
      },
    },
    flat: {
      enabled: {
        bg: 'bg-transparent hover:bg-btn-ai-bg-hover active:bg-btn-ai-bg-pressed',
        text: 'text-btn-ai-flat-text hover:text-btn-ai-flat-text-hover active:text-btn-ai-flat-text-pressed',
        border: 'border-btn-ai-border-flat hover:border-btn-ai-border-flat-hover active:border-btn-ai-border-flat-pressed!',
      },
      active: {
        bg: 'bg-btn-ai-bg-pressed!',
        text: 'text-btn-ai-flat-text-pressed',
        border: 'border-btn-ai-border-flat-pressed!',
      },
      disabled: {
        bg: 'bg-transparent',
        text: 'text-btn-ai-flat-text-disabled',
        border: 'border-btn-ai-border-flat-disabled',
      },
    },
  },
};
